import { Component, Vue } from 'vue-property-decorator'
import CommonUtil from '@/common/utils/CommonUtil'
import Store from '@/common/utils/Store'

const MESSAGE_ID = 'MSGSYSW0014'
@Component({
  name: 'C00G1080',
  components: {}
  })
export default class C00G1080Controller extends Vue {
  /**
   * 画面要素描画後処理
   */
  mounted() {
    this.init()
  }

  /**
   * 初期処理
   */
  private init() {
    const messageErrorArr = []
    messageErrorArr.push({
      code: MESSAGE_ID,
      message: CommonUtil.getMessage(MESSAGE_ID, []),
      url: ''
    })
    Store.setResponseErrors(messageErrorArr)
  }
}
